import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertInfo = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("circle", { cx: "10", cy: "4.5", r: "1.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("line", { x1: "10", y1: "9", x2: "10", y2: "16", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconAlertInfo.js.map